import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import PropTypes from 'prop-types';
import { EventHandler } from "./EventHandler";
import { clamp } from "../../../utils/math";
var normalizeAnimationStep = function normalizeAnimationStep(steps, varName) {
  return steps.map(function (step) {
    return step[varName];
  }).map(clamp(1, -1)).reduce(function (acc, next, index) {
    var prevEnd = (acc[index - 1] || {
      end: 0
    }).end;
    return [].concat(_toConsumableArray(acc), [{
      start: prevEnd,
      end: prevEnd + next
    }]);
  }, []);
};
export var Animation = /*#__PURE__*/function (_EventHandler) {
  _inherits(Animation, _EventHandler);
  var _super = _createSuper(Animation);
  function Animation() {
    var _this;
    _classCallCheck(this, Animation);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", Animation.getInitialState());
    _defineProperty(_assertThisInitialized(_this), "animationTimeoutId", null);
    _defineProperty(_assertThisInitialized(_this), "startAnimation", function () {
      _this.animationTimeoutId = setTimeout(_this.playAnimation, _this.props.delay);
    });
    _defineProperty(_assertThisInitialized(_this), "buildAnimationFn", function (steps, duration) {
      var start = Date.now();
      var end = steps.length * duration + start;
      return function () {
        if (!_this.state.playAnimation || steps.length === 0) {
          return {
            value: function value(pos) {
              return pos;
            },
            done: true
          };
        }
        var time = Date.now();
        if (!_this.props.infiniteDemo && time >= end) {
          return {
            value: function value(pos, length) {
              return steps[steps.length - 1].end * length;
            },
            done: true
          };
        }
        var deltaTime = time - start;
        var stepIndex = Math.floor(deltaTime / duration) % steps.length;
        var step = steps[stepIndex];
        var timeValue = deltaTime % duration / duration;
        return {
          value: function value(pos, length) {
            return ((step.end - step.start) * timeValue + step.start) * length;
          },
          done: false
        };
      };
    });
    _defineProperty(_assertThisInitialized(_this), "playAnimation", function () {
      var xSteps = normalizeAnimationStep(_this.props.steps, 'x');
      var ySteps = normalizeAnimationStep(_this.props.steps, 'y');
      var xAnimationFn = _this.buildAnimationFn(xSteps, _this.props.duration);
      var yAnimationFn = _this.buildAnimationFn(ySteps, _this.props.duration);
      _this.animation(xAnimationFn, yAnimationFn);
    });
    _defineProperty(_assertThisInitialized(_this), "scrollHandler", function () {
      if (typeof window === 'undefined' || !_this.container) return;
      if (_this.props.handleShouldPlayDemo(_this.container.getBoundingClientRect())) {
        window.removeEventListener('scroll', _this.scrollHandler);
        window.removeEventListener('resize', _this.scrollHandler);
        _this.startAnimation();
      }
    });
    return _this;
  }
  _createClass(Animation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(Animation.prototype), "componentDidMount", this).call(this);
      window.addEventListener('scroll', this.scrollHandler);
      window.addEventListener('resize', this.scrollHandler);
      this.scrollHandler();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.animationTimeoutId);
      window.removeEventListener('scroll', this.scrollHandler);
      window.removeEventListener('resize', this.scrollHandler);
      _get(_getPrototypeOf(Animation.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      this.setState({
        playAnimation: false
      });
      _get(_getPrototypeOf(Animation.prototype), "handleMouseDown", this).call(this, event);
    }
  }, {
    key: "handleTouchStart",
    value: function handleTouchStart(event) {
      this.setState({
        playAnimation: false
      });
      _get(_getPrototypeOf(Animation.prototype), "handleTouchStart", this).call(this, event);
    }
  }]);
  return Animation;
}(EventHandler);
_defineProperty(Animation, "propTypes", _objectSpread(_objectSpread({}, EventHandler.propTypes), {}, {
  duration: PropTypes.number,
  delay: PropTypes.number,
  steps: PropTypes.arrayOf(PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  })),
  infiniteDemo: PropTypes.bool,
  handleShouldPlayDemo: PropTypes.func
}));
_defineProperty(Animation, "defaultProps", _objectSpread(_objectSpread({}, EventHandler.defaultProps), {}, {
  duration: 1000,
  delay: 0,
  infiniteDemo: false,
  steps: [{
    x: 1,
    y: 0
  }, {
    x: -1,
    y: 0
  }],
  handleShouldPlayDemo: function handleShouldPlayDemo(_ref) {
    var top = _ref.top,
      bottom = _ref.bottom;
    return top >= 0 && bottom <= window.innerHeight;
  }
}));
_defineProperty(Animation, "getInitialState", function () {
  return _objectSpread(_objectSpread({}, EventHandler.getInitialState()), {}, {
    playAnimation: true
  });
});